import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApolloGradeService {

    constructor(private apollo: Apollo) { }

    getGradeList(): Observable<any[]> {
        const GET_GRADELIST = gql`
            query {
                grade {
                    allGrades(pageNo: 1) {
                        count
                        pageNo
                        pageSize
                        totalPages
                        data {
                            id
                            name
                            isStaffSpecificStudent
                            capping
                            registrationStatus
                            school {
                                id
                                name
                                description
                                address
                                postalCode
                                city
                                state {
                                    id
                                    name
                                }
                                weekend {
                                    id
                                    type
                                }
                            }
                            schoolYear {
                                id
                                year
                                month
                            }
                            operatingHour {
                                id
                                name
                                startTime
                                endTime
                                bufferTimeForOTCalc
                                refOperatingType {
                                    name
                                }
                                fees {
                                    name
                                    amount
                                    isMandatory
                                    discountType {
                                        name
                                        value
                                        type
                                    }
                                    otCalculation {
                                        name
                                        type
                                        calculationType
                                        isOverTime
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `;

        return this.apollo.query<any>({
            query: GET_GRADELIST,
            fetchPolicy: 'no-cache',
        }).pipe(
            map(result => {
                const gradeListData = result?.data?.grade?.allGrades?.data || [];
                return gradeListData;
            })
        );
    }


    checkGradeCapping(gradeId: number): Observable<any[]> {
        const GET_GRADELIST = gql`
            query {
                student {
                    checkGradeCapping(gradeId: ${gradeId}) {
                        success
                        error
                    }
                }
            }
        `;

        return this.apollo.watchQuery<any>({
            query: GET_GRADELIST,
            fetchPolicy: 'network-only',
        }).valueChanges.pipe(
            map(result => {
                const gradeListData = result?.data?.student?.checkGradeCapping || [];
                return gradeListData;
            })
        );
    }
    

    createGrade(input: any): Observable<any> {
        const inputString = Object.keys(input).map(key => {
            const value = input[key as keyof typeof input];

            if (value === null || value === undefined) {
                return null;
            } else if (Array.isArray(value)) {
                if (value.length === 0) {
                    return `${key}: null`;
                } else {
                    return `${key}: [${value.join(', ')}]`;
                }
            } else if (typeof value === 'string') {
                const escapedValue = value.replace(/[\n\r]/g, '\\n').replace(/"/g, '\\"');
                return `${key}: "${escapedValue}"`;
            } else {
                return `${key}: ${value}`;
            }
        }).filter(str => str !== null).join(', ');

        const CREATE_FEE = gql`
            mutation {
                grade {
                    addGrade(input: { ${inputString} }){
                        success
                        error
                    }
                }
            }
        `;

        return this.apollo.mutate<any>({
            mutation: CREATE_FEE
        }).pipe(
            map(result => {
                const fee = result?.data?.grade?.addGrade;
                return fee;
            })
        );
    }
    

    updateGrade(input: any): Observable<any> {
        const inputString = Object.keys(input).map(key => {
            const value = input[key as keyof typeof input];

            if (value === null || value === undefined) {
                return null;
            } else if (Array.isArray(value)) {
                if (value.length === 0) {
                    return `${key}: null`;
                } else {
                    return `${key}: [${value.join(', ')}]`;
                }
            } else if (typeof value === 'string') {
                const escapedValue = value.replace(/[\n\r]/g, '\\n').replace(/"/g, '\\"');
                return `${key}: "${escapedValue}"`;
            } else {
                return `${key}: ${value}`;
            }
        }).filter(str => str !== null).join(', ');

        const CREATE_FEE = gql`
            mutation {
                grade {
                    updateGrade(input: { ${inputString} }){
                        success
                        error
                    }
                }
            }
        `;

        return this.apollo.mutate<any>({
            mutation: CREATE_FEE
        }).pipe(
            map(result => {
                const fee = result?.data?.grade?.updateGrade;
                return fee;
            })
        );
    }


    deleteGrade(id: number): Observable<any> {
        const DELETE_CLASS = gql`
            mutation {
                grade {
                    deleteGrade(input:  {
                        id: ${id},
                    }){
                        success
                        error
                    }
                }
            }
        `;

        return this.apollo.mutate<any>({
            mutation: DELETE_CLASS,
        }).pipe(
            map(result => {
                const classDetail = result?.data?.grade?.deleteGrade;
                return classDetail;
            })
        );
    }
    

    private removeTypename(data: any): any {
        if (Array.isArray(data)) {
            return data.map(item => this.removeTypename(item));
        } else if (data !== null && typeof data === 'object') {
            const newObj: any = {};
            Object.keys(data).forEach(key => {
                if (key !== '__typename') {
                    newObj[key] = this.removeTypename(data[key]);
                }
            });
            return newObj;
        }
        return data;
    }
}
